import Image from "@/components/Image";
import { Modal } from "@/components/Modals/Modal";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";

export const LIST_TOKEN = [
  { id: 0, image: "/token_exchange/token_1.png" },
  { id: 1, image: "/token_exchange/token_2.png" },
  { id: 2, image: "/token_exchange/token_3.png" },
  { id: 3, image: "/token_exchange/token_4.png" },
  { id: 4, image: "/token_exchange/token_5.png" },
  { id: 5, image: "/token_exchange/token_6.png" },
  { id: 6, image: "/token_exchange/token_7.png" },
];

export function ModalDefuture(props: { onClose: () => void }) {
  return (
    <Modal isOpen={true} position="right" onClose={() => props.onClose()}>
      <div className="flex flex-col gap-2 md:w-80 w-full px-2 py-5">
        <div className="flex flex-col gap-4 p-5 rounded-3xl bg-white">
          <div className="flex gap-4 items-center flex-col md:flex-row">
            <Image
              src={require("@/assets/images/menu/DeFutures.png")}
              alt="Exchange"
              className="w-20 h-20 md:w-12 md:h-12"
              width={400}
              height={400}
            />
            <p className="text-2xl font-medium text-black">Defutures</p>
          </div>

          <Link
            to={"https://holdstation.exchange/trading?p=BTCUSD"}
            target="_blank"
            className="hidden md:flex items-center justify-center bg-black w-full rounded-[90px] px-8 py-4"
          >
            <span className="text-base text-white font-medium">Launch App</span>
          </Link>
        </div>

        <div className="p-5 rounded-3xl bg-[#F4F5F6] md:bg-white border md:border-none border-solid border-[#E6E8EC]">
          <p className="text-2xl text-[#777E90] font-medium">
            A perpdex platform, powered on ZKsync Era, accessible on mobile and
            web. Enjoy gasless transactions and cheaper fees for efficient,
            seamless trading.
          </p>
        </div>

        <div className="flex flex-col gap-8 py-8 rounded-3xl bg-[#F4F5F6] md:bg-white border md:border-none border-solid border-[#E6E8EC]">
          <div className="flex flex-col gap-4">
            <Marquee className="flex items-center gap-6">
              <div className="flex gap-4 items-center flex-shrink-0 min-w-full">
                {LIST_TOKEN.map((item, index) => (
                  <div
                    key={index.toString()}
                    className="flex-shrink-0 rounded-2xl w-16 h-16 overflow-hidden"
                  >
                    <Image
                      src={item.image}
                      alt={`Image ${index}`}
                      className="w-full h-full object-contain"
                    />
                  </div>
                ))}
              </div>
            </Marquee>

            <Marquee direction="right" className="flex items-center gap-6">
              <div className="flex gap-4 items-center flex-shrink-0 min-w-full">
                {LIST_TOKEN.map((item, index) => (
                  <div
                    key={index.toString()}
                    className="flex-shrink-0 rounded-2xl w-16 h-16 overflow-hidden"
                  >
                    <Image
                      src={item.image}
                      alt={`Image ${index}`}
                      className="w-full h-full object-contain"
                    />
                  </div>
                ))}
              </div>
            </Marquee>
          </div>

          <div className="px-5">
            <p className="text-sm font-medium text-[#777E90]">
              Top trading pairs
            </p>
            <p className="mt-1 text-2xl text-black font-medium">
              Start Trading Right Now
            </p>
          </div>
        </div>

        <Link
          data-action="redirect_holdstation.exchange"
          to={"https://holdstation.exchange/trading?p=BTCUSD"}
          target="_blank"
          className="fixed md:hidden bottom-10 bg-black w-fit min-w-44 rounded-[90px] px-8 py-4 left-1/2 transform -translate-x-1/2 text-center"
        >
          <p className="text-base text-white font-medium">Launch App</p>
        </Link>
      </div>
    </Modal>
  );
}
